import { request as baseRequest } from '@common/react/components/Api';

import { ApplicationState } from '@app/store';
import { User } from '@app/objects/User';

export function request<T>(type: string, data?: any, state?: ApplicationState) {
	return baseRequest<T, User, ApplicationState>(type, data, state);
}
